module.exports = __webpack_public_path__ + "img/pr.fcec6063.svg";